<script module lang="ts">
  const FINDING_STATUSES = ["open", "acknowledged", "resolved", "dismissed", "closed"];

  export type FindingStatus = (typeof FINDING_STATUSES)[number];
</script>

<script lang="ts">
  import { toTitleCase } from "$lib/utils/text";
  import * as Select from "$ui/select";

  export const {
    selectAll = false,
    readonlyStatuses,
    onChange,
    value,
    placeholder,
    sameWidth = true,
    disabled = false,
  }: {
    selectAll?: boolean;
    placeholder?: string;
    value?: FindingStatus;
    sameWidth?: boolean;
    readonlyStatuses: FindingStatus[];
    onChange?: (status: FindingStatus | null) => void;
    disabled?: boolean;
  } = $props();
  let findingStatuses =
    readonlyStatuses && readonlyStatuses.length > 0
      ? FINDING_STATUSES.filter((s) => !readonlyStatuses.includes(s))
      : FINDING_STATUSES;
</script>

<div class="min-w-[8rem]">
  <Select.Root
    onSelectedChange={(selectedStatus) => {
      if (selectAll && selectedStatus?.value === "all") {
        onChange && onChange(null);
      } else {
        onChange && onChange(selectedStatus?.value as FindingStatus);
      }
    }}
    {disabled}
  >
    <Select.Trigger name="alias">
      <Select.Value placeholder={toTitleCase(value || placeholder || "No Status")} />
    </Select.Trigger>
    <Select.Content {sameWidth}>
      <Select.Group>
        {#if selectAll}
          <Select.Item value="all" label={placeholder} isSelected={!value}>
            {placeholder}
          </Select.Item>
        {/if}
        {#each findingStatuses as findingStatus}
          <Select.Item value={findingStatus} label={toTitleCase(findingStatus)} isSelected={findingStatus === value}>
            {toTitleCase(findingStatus)}
          </Select.Item>
        {/each}
      </Select.Group>
    </Select.Content>
  </Select.Root>
</div>
